function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function readString(
  value: Record<string, unknown>,
  key: string
): string | null {
  const nestedValue = value[key];
  return typeof nestedValue === "string" && nestedValue.trim().length > 0
    ? nestedValue
    : null;
}

export function getErrorMessage(
  error: unknown,
  fallback = "Something went wrong. Please try again."
): string {
  if (typeof error === "string" && error.trim().length > 0) {
    return error;
  }

  if (error instanceof Error && error.message.trim().length > 0) {
    return error.message;
  }

  if (isRecord(error)) {
    const directMessage = readString(error, "message");
    if (directMessage) {
      return directMessage;
    }

    const nestedError = error.error;
    if (isRecord(nestedError)) {
      const nestedMessage = readString(nestedError, "message");
      if (nestedMessage) {
        return nestedMessage;
      }
    }
  }

  return fallback;
}

export function getFirstErrorMessage(
  errors: ReadonlyArray<unknown> | undefined
): string | null {
  if (!errors) {
    return null;
  }

  for (const error of errors) {
    const message = getErrorMessage(error, "");
    if (message) {
      return message;
    }
  }

  return null;
}
